<template>
  <div style="padding: 0 10px">
    <From @search="searchCall" :selRow="selRow" />
    <WmsTable :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall" :isExpanded_hidden="true"
      :isPagination="query" :isRowSelection="true" @selectChange="rowSelectChange" :hasHeader="false" style="margin-top:20px">
      <ImgView slot="productImgAction" slot-scope="{ text, record, index }" :src="text"></ImgView>
      <div slot="action" slot-scope="{ text, record, index }">
        <el-button type="text">详情</el-button>
      </div>

      <div slot="expandedRender" slot-scope="{ record }">
        <!-- <el-table :data="record.items" style="width: 100%" :border="true">
          <el-table-column label="批次包编码" prop="pkgCode"></el-table-column>
          <el-table-column label="商品sku" prop="shopProductSku"></el-table-column>
          <el-table-column label="数量" prop="amount"></el-table-column>
          <el-table-column label="库位" prop="gridCode">
            <template slot-scope="scope">
              <div>
                {{ scope.row.gridCode || '-'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="上架时间" prop="upShelfTime">
            <template slot-scope="scope">
              <div>
                {{ scope.row.upShelfTime || '-'}}
              </div>
            </template>
          </el-table-column>
        </el-table> -->
        <WmsTable :columns="colItem" :dataSource="record.items" :isPagination="false" :hasHeader="false">

        </WmsTable>
      </div>
    </WmsTable>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import From from "@/views/inventoryDetails/transferLedger/components/From";
import { columns,colItem } from "@/views/inventoryDetails/transferLedger/indexData";
import { transferPage } from "@/apis/inventoryDetails";
export default {
  title: "移库台账",
  name: "TransferLedger",
  components: {
    WmsTable,
    From
  },
  data() {
    return {
      columns,
      colItem,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
      selRow: []
    };
  },
  methods: {
    searchCall: function (fromData) {
      this.formInline = fromData;
      if (fromData.date) {
        fromData.startTime = fromData.date[0]
        fromData.endTime = fromData.date[1]
      }
      this.query.current = 1;
      this.query.total = 1;
      this.getDataSource();
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    getDataSource: function () {
      let params = {
        pageSize: this.query.pageSize,
        pageNum: this.query.current,
        ...this.formInline,
      };
      transferPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    rowSelectChange: function (rows) {
      this.selRow = rows
    }
  },
};
</script>

<style scoped></style>
